// extracted by mini-css-extract-plugin
export default {"bar":"ScrollingTextBar_bar__ECbfd","scrollingText":"ScrollingTextBar_scrollingText__3ZPO6"};